import React from 'react';
import { CheckBox } from '../../../../formikBindings';
import { ICheckAnswerProps } from './types';

export const CheckAnswer: React.FC<ICheckAnswerProps> = ({ name, label, enablestatus }) => (
    <CheckBox label={label} name={name} disabled={!enablestatus} />
);
